import { LEVELS_API_V2_URLS } from "@/programs/urls.js";
import { API } from "@/programs/types.ts";
import {
  restfulCreateForm,
  restfulShow,
} from "@/programs/services/ServiceHelpers.ts";

interface CollectionURLParams {
  programId: number;
}

interface DetailUrlParams extends CollectionURLParams {
  levelId: number;
}

export const getLevelOptions = restfulShow<
  CollectionURLParams,
  API.Admin.LevelOption[]
>(LEVELS_API_V2_URLS.options);

export interface MassLevelPayload {
  comment: string;
  emails: File;
}
export interface MassLevelResponse {
  message: string;
}
export const postMassLevel = restfulCreateForm<
  DetailUrlParams,
  MassLevelResponse,
  MassLevelPayload
>(LEVELS_API_V2_URLS.massLevel);

export interface MassLevelPreviewPayload {
  level: number;
  comment: string;
  emails: File;
}
interface Level {
  id: number;
  name: string;
  order: number;
}
export interface MassLevelPreviewResponse {
  notFoundEmails: string[];
  level: Level;
  comment: string;
  memberLevels: CourseMembership[];
}
interface CourseMembership {
  email: string;
  id: number;
  currentLevel: Level;
}

export const postMassLevelPreview = restfulCreateForm<
  DetailUrlParams,
  MassLevelPreviewResponse,
  MassLevelPreviewPayload
>(LEVELS_API_V2_URLS.massLevelPreview);
